// // // Helper function to set a cookie
// // if (!document.cookie.includes('countryValueDomain')) {

// //     function setCookie(name, value, days, domain) {
// //         const date = new Date();
// //         date.setTime(date.getTime() + days  * 24 * 60  * 60 * 1000);
// //         const expires = `expires=${date.toUTCString()}`;
// //         const domainAttr = domain ? `; domain=${domain}` : '';
// //         document.cookie = `${name}=${value}; ${expires}; path=/ ${domainAttr}`;
// //     }
    
// //     // Helper function to get a cookie by name
// //     function getCookie(name) {
// //         const cookies = document.cookie.split(';');
// //         for (let cookie of cookies) {
// //             const [key, value] = cookie.trim().split('=');
// //             if (key === name) return value;
// //         }
// //         return null;
// //     }
    
// //     // Country redirects map
// //     const countryRedirects = {
// //         "UK": "https://uk.houseofnoya.com",
// //         "QA": "https://qa.houseofnoya.com",
// //         "KW": "https://kw.houseofnoya.com",
// //         "OM": "https://om.houseofnoya.com",
// //         "BH": "https://bh.houseofnoya.com",
// //         "SA": "https://ksa.houseofnoya.com",
// //         "AE": "https://uae.houseofnoya.com",
// //         "US": "https://houseofnoya.com",
// //         "NL": "https://eu.houseofnoya.com",
// //         "BE": "https://eu.houseofnoya.com",
// //         "BG": "https://eu.houseofnoya.com",
// //         "CY": "https://eu.houseofnoya.com",
// //         "DK": "https://eu.houseofnoya.com",
// //         "DE": "https://eu.houseofnoya.com",
// //         "EE": "https://eu.houseofnoya.com",
// //         "FI": "https://eu.houseofnoya.com",
// //         "FR": "https://eu.houseofnoya.com",
// //         "GR": "https://eu.houseofnoya.com",
// //         "HU": "https://eu.houseofnoya.com",
// //         "IE": "https://eu.houseofnoya.com",
// //         "IT": "https://eu.houseofnoya.com",
// //         "HR": "https://eu.houseofnoya.com",
// //         "LV": "https://eu.houseofnoya.com",
// //         "LU": "https://eu.houseofnoya.com",
// //         "MT": "https://eu.houseofnoya.com",
// //         "AT": "https://eu.houseofnoya.com",
// //         "PL": "https://eu.houseofnoya.com",
// //         "PT": "https://eu.houseofnoya.com",
// //         "RO": "https://eu.houseofnoya.com",
// //         "SI": "https://eu.houseofnoya.com",
// //         "SK": "https://eu.houseofnoya.com",
// //         "ES": "https://eu.houseofnoya.com",
// //         "CZ": "https://eu.houseofnoya.com",
// //         "SE": "https://eu.houseofnoya.com",
// //         "CH": "https://eu.houseofnoya.com",
// //         "NO": "https://eu.houseofnoya.com",
// //         "BA": "https://eu.houseofnoya.com",
// //         "IS": "https://eu.houseofnoya.com",
// //         "LI": "https://eu.houseofnoya.com",
// //         "MC": "https://eu.houseofnoya.com",
// //         "RS": "https://eu.houseofnoya.com",
// //         "AU": "https://eu.houseofnoya.com",
// //         "BR": "https://eu.houseofnoya.com",
// //         "CA": "https://houseofnoya.com",
// //         "CN": "https://eu.houseofnoya.com",
// //         "HK": "https://eu.houseofnoya.com",
// //         "JP": "https://eu.houseofnoya.com",
// //         "NZ": "https://eu.houseofnoya.com",
// //     };
    
// //     // Check if a country cookie exists
// //     const countryCodeCookie = getCookie('countryCodes');
   
    
// //     if (countryCodeCookie) {
// //         // Redirect based on cookie value
// //         const redirectUrl = countryRedirects[countryCodeCookie];
// //         if (redirectUrl) {
// //             console.log(`Redirecting to ${redirectUrl} based on cookie.`);
// //             if(countryCode!==customCountryValue){
// //             window.location.href = redirectUrl;
// //             }
// //         } else {
// //             console.log("No redirection available for this country.");
// //         }
// //     } else {
// //         // Fetch country code from IPWHOIS API
// //         $.getJSON("https://ipwhois.app/json/", function (data) {
// //             const countryCode = data.country_code;
// //             const redirectUrl = countryRedirects[countryCode];
// //             console.log("url",redirectUrl);
// //             let customCountryValue = document.getElementById("hon-country-localization__disclosure-button").querySelector('p').innerHTML ;
// //             if (redirectUrl) {
// //                 // Set a cookie for future visits (valid for 30 days, across all subdomains)
// //                 setCookie('countryCodes', countryCode, 30, '.houseofnoya.com');
// //                 console.log(`Redirecting to ${redirectUrl} based on API data.`);
// //                 if(countryCode!==customCountryValue){
// //                     window.location.href = redirectUrl;
// //                 }
// //             } else {
// //                 console.log("No redirection available for this country.");
// //             }
// //         }).fail(function () {
// //             console.error("Failed to fetch geolocation data.");
// //         });
// //     }
    
    
// //     }
   
// const countryRedirects = {
//   "UK": "uk.houseofnoya.com",
//   "QA": "qa.houseofnoya.com",
//   "KW": "kw.houseofnoya.com",
//   "OM": "om.houseofnoya.com",
//   "BH": "bh.houseofnoya.com",
//   "SA": "ksa.houseofnoya.com",
//   "AE": "uae.houseofnoya.com",
//   "US": "us.houseofnoya.com",
//   "NL": "us.houseofnoya.com",
//   "BE": "us.houseofnoya.com",
//   "BG": "us.houseofnoya.com",
//   "CY": "us.houseofnoya.com",
//   "DK": "us.houseofnoya.com",
//   "DE": "us.houseofnoya.com",
//   "EE": "us.houseofnoya.com",
//   "FI": "us.houseofnoya.com",
//   "FR": "us.houseofnoya.com",
//   "GR": "us.houseofnoya.com",
//   "HU": "us.houseofnoya.com",
//   "IE": "us.houseofnoya.com",
//   "IT": "us.houseofnoya.com",
//   "HR": "us.houseofnoya.com",
//   "LV": "us.houseofnoya.com",
//   "LU": "us.houseofnoya.com",
//   "MT": "us.houseofnoya.com",
//   "AT": "us.houseofnoya.com",
//   "PL": "us.houseofnoya.com",
//   "PT": "us.houseofnoya.com",
//   "RO": "us.houseofnoya.com",
//   "SI": "us.houseofnoya.com",
//   "SK": "us.houseofnoya.com",
//   "ES": "us.houseofnoya.com",
//   "CZ": "us.houseofnoya.com",
//   "SE": "us.houseofnoya.com",
//   "CH": "us.houseofnoya.com",
//   "NO": "us.houseofnoya.com",
//   "BA": "us.houseofnoya.com",
//   "IS": "us.houseofnoya.com",
//   "LI": "us.houseofnoya.com",
//   "MC": "us.houseofnoya.com",
//   "RS": "us.houseofnoya.com",
//   "AU": "us.houseofnoya.com",
//   "BR": "us.houseofnoya.com",
//   "CA": "houseofnoya.com",
//   "CN": "us.houseofnoya.com",
//   "HK": "us.houseofnoya.com",
//   "JP": "us.houseofnoya.com",
//   "NZ": "us.houseofnoya.com"
  
// };

// function getCookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);

//   if (parts.length > 1) {
//     return parts.pop().split(';').shift();
//   }
//   return null;
// }
// if (window.location.hostname === "us.houseofnoya.com") {
//   let cookieValue = getCookie('countryValue')
//   $.getJSON("https://ipwhois.app/json/", function (data) {
//       const countryCode = data.country_code;
//       if( !['US','CA'].includes(countryCode)){
//       console.log("Detected country code:", countryCode);
//       const redirectUrl = countryRedirects[countryCode];
//       if (( !['US','CA'].includes(cookieValue)) && (redirectUrl && redirectUrl !== window.location.hostname)) {
//         console.log("cookieValue",cookieValue);
//           console.log(`Redirecting to: ${redirectUrl}`);
//           window.location.hostname = redirectUrl;
//       } else {
//           console.log("No redirection required or URL already correct.");
//       }
//   }
//   }).fail(function () {
//       console.error("Failed to fetch geolocation data.");
//   });
// }
// else if (window.location.hostname === "eu.houseofnoya.com") {
// window.location.hostname = "us.houseofnoya.com";
// }
const countryRedirects = {
    "UK": "uk.houseofnoya.com",
    "QA": "qa.houseofnoya.com",
    "KW": "kw.houseofnoya.com",
    "OM": "om.houseofnoya.com",
    "BH": "bh.houseofnoya.com",
    "SA": "ksa.houseofnoya.com",
    "AE": "uae.houseofnoya.com",
    "US": "us.houseofnoya.com",
    "NL": "us.houseofnoya.com",
    "BE": "us.houseofnoya.com",
    "BG": "us.houseofnoya.com",
    "CY": "us.houseofnoya.com",
    "DK": "us.houseofnoya.com",
    "DE": "us.houseofnoya.com",
    "EE": "us.houseofnoya.com",
    "FI": "us.houseofnoya.com",
    "FR": "us.houseofnoya.com",
    "GR": "us.houseofnoya.com",
    "HU": "us.houseofnoya.com",
    "IE": "us.houseofnoya.com",
    "IT": "us.houseofnoya.com",
    "HR": "us.houseofnoya.com",
    "LV": "us.houseofnoya.com",
    "LU": "us.houseofnoya.com",
    "MT": "us.houseofnoya.com",
    "AT": "us.houseofnoya.com",
    "PL": "us.houseofnoya.com",
    "PT": "us.houseofnoya.com",
    "RO": "us.houseofnoya.com",
    "SI": "us.houseofnoya.com",
    "SK": "us.houseofnoya.com",
    "ES": "us.houseofnoya.com",
    "CZ": "us.houseofnoya.com",
    "SE": "us.houseofnoya.com",
    "CH": "us.houseofnoya.com",
    "NO": "us.houseofnoya.com",
    "BA": "us.houseofnoya.com",
    "IS": "us.houseofnoya.com",
    "LI": "us.houseofnoya.com",
    "MC": "us.houseofnoya.com",
    "RS": "us.houseofnoya.com",
    "AU": "us.houseofnoya.com",
    "BR": "us.houseofnoya.com",
    "CA": "houseofnoya.com",
    "CN": "us.houseofnoya.com",
    "HK": "us.houseofnoya.com",
    "JP": "us.houseofnoya.com",
    "NZ": "us.houseofnoya.com"
  };
  
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length > 1) {
      return parts.pop().split(';').shift();
    }
    return null;
  }
  
  // Handle eu.houseofnoya.com redirect
  if (window.location.hostname === "eu.houseofnoya.com") {
    window.location.hostname = "us.houseofnoya.com";
  } 
  // Handle us.houseofnoya.com geolocation-based redirects
  else if (window.location.hostname === "us.houseofnoya.com") {
    let cookieValue = getCookie('countryValue');
    
    $.getJSON("https://ipwhois.app/json/", function (data) {
      const countryCode = data.country_code;
      
      if (!['US', 'CA'].includes(countryCode)) {
        console.log("Detected country code:", countryCode);
        const redirectUrl = countryRedirects[countryCode];
        
        if ((!['US', 'CA'].includes(cookieValue)) && (redirectUrl && redirectUrl !== window.location.hostname)) {
          console.log("cookieValue", cookieValue);
          console.log(`Redirecting to: ${redirectUrl}`);
          window.location.hostname = redirectUrl;
        } else {
          console.log("No redirection required or URL already correct.");
        }
      }
    }).fail(function () {
      console.error("Failed to fetch geolocation data.");
    });
  }